// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"0b38f8b9ed91d79177ff","453":"391c3dbf2e2a09562019"}[chunkId] + ".js";
};